"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _HeaderButton = _interopRequireDefault(require("./HeaderButton"));

var _HeaderNavigation = _interopRequireDefault(require("./HeaderNavigation"));

var _types = require("./types");

var _useWindowDimensions2 = require("./hooks/useWindowDimensions");

var _ProfileMenu = _interopRequireDefault(require("../ProfileMenu"));

var _Navigation = _interopRequireWildcard(require("../Navigation"));

var _constants = require("../Icon/constants");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** Use the header according to the current context of the displayed page. */
function Header(_ref) {
  var logo = _ref.logo,
      title = _ref.title,
      content = _ref.content,
      link = _ref.link,
      children = _ref.children,
      profileInfo = _ref.profileInfo,
      navigation = _ref.navigation,
      navigationTablet = _ref.navigationTablet,
      navigationOpen = _ref.navigationOpen,
      closeNavigation = _ref.closeNavigation,
      leftButton = _ref.leftButton,
      rightButton = _ref.rightButton,
      onLeftButtonClick = _ref.onLeftButtonClick,
      onRightButtonClick = _ref.onRightButtonClick;

  var _useWindowDimensions = (0, _useWindowDimensions2.useWindowDimensions)(),
      isDesktop = _useWindowDimensions.isDesktop,
      isTablet = _useWindowDimensions.isTablet,
      isMobile = _useWindowDimensions.isMobile;

  var _children = _slicedToArray(children, 2),
      leftButtonElement = _children[0],
      rightButtonElement = _children[1];

  var className = (0, _utils.getClassNames)('header', {
    'header_with-navigation': navigation.length > 0
  });
  var headerLogo = (0, _react.useMemo)(function () {
    return logo ? /*#__PURE__*/_react.default.createElement("img", {
      src: logo,
      alt: title
    }) : content;
  }, [logo, title, content]);
  var headerLogoLink = (0, _react.useMemo)(function () {
    var headerLogoLinkComponent = headerLogo;
    var LinkComponent = link;
    headerLogoLinkComponent = typeof link === 'string' ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: link,
      title: title
    }, headerLogo) : headerLogoLinkComponent;
    headerLogoLinkComponent = typeof link === 'function' ? /*#__PURE__*/_react.default.createElement(LinkComponent, null, headerLogo) : headerLogoLinkComponent;
    return headerLogoLinkComponent;
  }, [headerLogo, link]);

  var headerAvatarMenu = /*#__PURE__*/_react.default.createElement(_ProfileMenu.default, profileInfo);

  var navigationMobile = navigationTablet || /*#__PURE__*/_react.default.createElement(_Navigation.default, {
    isOpen: navigationOpen,
    onClose: closeNavigation
  }, navigation.map(function (_ref2) {
    var title = _ref2.title,
        link = _ref2.link,
        rest = _objectWithoutProperties(_ref2, ["title", "link"]);

    return /*#__PURE__*/_react.default.createElement(_Navigation.NavigationLink, _extends({
      to: link
    }, rest), title);
  }));

  var headerLeft = leftButtonElement || /*#__PURE__*/_react.default.createElement(_HeaderButton.default, {
    type: leftButton.type,
    ariaLabel: leftButton.ariaLabel,
    className: "left-button",
    onClick: onLeftButtonClick
  }, leftButton.label);

  var headerRight = rightButtonElement || /*#__PURE__*/_react.default.createElement(_HeaderButton.default, {
    type: rightButton.type,
    className: "right-button",
    onClick: onRightButtonClick
  }, rightButton.label);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("header", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header__left"
  }, isDesktop && navigation.length > 0 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "header__logo"
  }, headerLogoLink) : headerLeft), /*#__PURE__*/_react.default.createElement("div", {
    className: "header__center"
  }, isDesktop && navigation.length > 0 ? /*#__PURE__*/_react.default.createElement(_HeaderNavigation.default, {
    navigation: navigation
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "header__logo"
  }, headerLogoLink)), /*#__PURE__*/_react.default.createElement("div", {
    className: "header__right"
  }, navigation.length > 0 ? headerAvatarMenu : headerRight))), isTablet || isMobile ? navigationMobile : null);
}

Header.propTypes = {
  /** Source for the Logo */
  logo: _propTypes.default.node,

  /** Alternative text for logo image and title attribute for the link */
  title: _propTypes.default.string,

  /** Logo link */
  link: _propTypes.default.string || _propTypes.default.node,

  /** Header navigation */
  navigation: _propTypes.default.arrayOf(_propTypes.default.shape({
    link: _propTypes.default.string,
    title: _propTypes.default.string,
    active: _propTypes.default.bool,
    hasChanges: _propTypes.default.bool
  })),

  /** Header profile props */
  profileInfo: _propTypes.default.shape({
    image: _propTypes.default.string,
    notifications: _propTypes.default.object,
    name: _propTypes.default.string,
    email: _propTypes.default.string,
    editText: _propTypes.default.string,
    logoutText: _propTypes.default.string,
    withAlert: _propTypes.default.bool,
    onEdit: _propTypes.default.func,
    onLogout: _propTypes.default.func
  }),

  /** Navigation menu for mobile version */
  navigationTablet: _propTypes.default.node,

  /** Navigation menu isOpen */
  navigationOpen: _propTypes.default.bool,

  /** @ignore */
  children: _propTypes.default.node,

  /** Default Icon and Label for left button */
  leftButton: _types.buttonConfig,

  /** Default Icon and Label for right button */
  rightButton: _types.buttonConfig,

  /** The callback function that is triggered when the close button is clicked */
  closeNavigation: _propTypes.default.func,

  /** Handler for onClick to the left button ('menu' for default header) */
  onLeftButtonClick: _propTypes.default.func,

  /** Handler for onClick to the right button ('login' for default header) */
  onRightButtonClick: _propTypes.default.func
};
Header.defaultProps = {
  logo: null,
  title: 'Advisory',
  link: '/',
  navigation: [],
  profileInfo: {
    image: '',
    notifications: [],
    name: undefined,
    email: undefined,
    editText: 'Edit profile',
    logoutText: 'Logout',
    withAlert: false,
    onEdit: function onEdit() {},
    onLogout: function onLogout() {}
  },
  navigationTablet: undefined,
  navigationOpen: false,
  children: [],
  leftButton: {
    type: _constants.ICON_TYPE_MENU,
    label: null,
    ariaLabel: 'Open menu'
  },
  rightButton: {
    type: _constants.ICON_TYPE_LOGIN,
    label: null
  },
  closeNavigation: function closeNavigation() {},
  onLeftButtonClick: function onLeftButtonClick() {},
  onRightButtonClick: function onRightButtonClick() {}
};
var _default = Header;
exports.default = _default;